// src/utils/tiempos.js
import { parseISO } from "./fecha";

export const LABELS = {
  JORNADA: "Jornada",
  DESCANSO: "Descanso (comida)",
  EFECTIVO: "Tiempo efectivo",
};

function safeDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v === "string" || typeof v === "number") {
    const d = parseISO(v);
    return d && !isNaN(d) ? d : null;
  }
  if (typeof v === "object") {
    return safeDate(v.timestamp || v.ts || v.iso || null);
  }
  return null;
}

export function formatDuracionMin(mins = 0) {
  const m = Math.max(0, Number(mins) || 0);
  const h = Math.floor(m / 60);
  const mm = m % 60;
  if (h && mm) return `${h}h ${mm}m`;
  if (h) return `${h}h`;
  return `${mm}m`;
}

function minutesBetween(a, b) {
  if (!a || !b) return 0;
  return Math.max(0, Math.floor((b.getTime() - a.getTime()) / 60000));
}

export function calcularResumenDia(
  intervalos = [],
  { pausaFijaMin = 0, pausaFijaEnabled = false } = {}
) {
  const closed = [];
  let diaAbierto = false;

  intervalos.forEach((it) => {
    const ini = safeDate(it.inicio || it.start || it.entrada || it.in);
    const fin = safeDate(it.fin || it.end || it.salida || it.out);
    const durMin =
      typeof it.duracionMin === "number"
        ? it.duracionMin
        : typeof it.duracion === "number"
        ? Math.floor(it.duracion / 60)
        : null;

    if (ini && fin && fin >= ini) {
      closed.push({ ini, fin, durMin });
    } else if (ini && !fin) {
      diaAbierto = true;
      if (typeof durMin === "number" && durMin > 0) {
        closed.push({ ini, fin: new Date(ini.getTime() + durMin * 60000), durMin });
      }
    }
  });

  if (closed.length === 0) {
    return { jornadaMin: 0, descansoMin: 0, efectivoMin: 0, diaAbierto };
  }

  closed.sort((a, b) => a.ini - b.ini);

  const efectivoMin = closed.reduce(
    (acc, it) => acc + (typeof it.durMin === "number" ? it.durMin : minutesBetween(it.ini, it.fin)),
    0
  );

  if (diaAbierto) {
    return {
      jornadaMin: efectivoMin,
      descansoMin: 0,
      efectivoMin,
      diaAbierto: true,
    };
  }

  const primera = closed[0].ini;
  const ultima = closed[closed.length - 1].fin;
  const jornadaMin = minutesBetween(primera, ultima);
  const descansoFichado = Math.max(jornadaMin - efectivoMin, 0);

  let descansoMin = 0;
  if (descansoFichado > 0) {
    descansoMin = descansoFichado;
  } else if (pausaFijaEnabled && Number(pausaFijaMin) > 0) {
    descansoMin = Math.min(Number(pausaFijaMin), jornadaMin);
  }

  return {
    jornadaMin,
    descansoMin,
    efectivoMin: Math.max(jornadaMin - descansoMin, 0),
    diaAbierto: false,
  };
}

export function detectarDescansoConstante(
  dias = [],
  { toleranceMin = 5 } = {}
) {
  const vals = dias.map((d) => Number(d?.descansoMin || 0)).filter((v) => v > 0);
  const totalDescanso = vals.reduce((a, b) => a + b, 0);
  const diasConDescanso = vals.length;
  const totalDias = Array.isArray(dias) ? dias.length : 0;

  if (!totalDias || !diasConDescanso) {
    return {
      esConstante: false,
      valorBaseMin: 0,
      diasConDescanso,
      totalDescansoMin: totalDescanso,
      mediaDescansoMin: 0,
      minDescansoMin: 0,
      maxDescansoMin: 0,
    };
  }

  const base = Math.round(totalDescanso / diasConDescanso);
  const ratio = diasConDescanso / totalDias;
  const esConstante =
    ratio >= 0.8 && vals.every((v) => Math.abs(v - base) <= toleranceMin);

  return {
    esConstante,
    valorBaseMin: base,
    diasConDescanso,
    totalDescansoMin: totalDescanso,
    mediaDescansoMin: Math.round(totalDescanso / diasConDescanso),
    minDescansoMin: Math.min(...vals),
    maxDescansoMin: Math.max(...vals),
  };
}
